export function z4 (n) {
  return ('0000' + n).slice(-4)
}

export function z3 (n) {
  return ('000' + n).slice(-3)
}

export function z2 (n) {
  return ('00' + n).slice(-2)
}

//
// Date オブジェクトのクローンを作成する
//
export function clone (dt) {
  return new Date(dt.valueOf())
}

//
// 今日 (時刻なし)を返す
//
export function today () {
  const tm = new Date()
  tm.setHours(0, 0, 0, 0)
  return tm
}

//
// 2019-10-01 の文字列をローカル時刻として Date オブジェクトを作成する
//
export function make (s) {
  return s ? new Date(s.replace(/-/g, '/')) : null
}

//
// 年月日から Date オブジェクトを作成する
//
export function create (y, m, d, h = 0, n = 0, s = 0) {
  return new Date(y, m - 1, d, h, n, s, 0)
}

//
// 日付と時刻から Date オブジェクトを作成する
//
export function join (date, time) {
  if (!date) {
    return null
  }
  if (!time) {
    time = '00:00'
  }
  return make(`${date.replace(/-/g, '/')} ${time}:00`)
}

//
// 指定時間後に、resolve する
//
export function wait (ms) {
  return new Promise(resolve => {
    setTimeout(() => {
      resolve()
    }, ms)
  })
}
